interface TeacherName {
  id: number | string
  name?: string | null
}

export const isUserAdditionalTeacher = (
  teachers: readonly TeacherName[] | null | undefined,
  userId: number | string | null | undefined,
): boolean => {
  if (userId === null || userId === undefined) return false

  return Boolean(
    teachers?.some((teacher) => String(teacher.id) === String(userId)),
  )
}

export const getAdditionalTeacherNames = (
  permanent: readonly TeacherName[] | null = [],
  temporary: readonly TeacherName[] | null = [],
): string[] => {
  const seen = new Set<string>()
  const names: string[] = []
  for (const [teachers, isTemporary] of [[permanent ?? [], false], [temporary ?? [], true]] as const) {
    for (const teacher of teachers) {
      const id = String(teacher.id)
      if (!teacher.name || seen.has(id)) continue
      seen.add(id)
      names.push(isTemporary ? `${teacher.name} (замена)` : teacher.name)
    }
  }
  return names
}
